// extracted by mini-css-extract-plugin
export default {"inline":"BFp8KdJEYxMZOgGAbZAQ"};